import React, { useState } from 'react';
import * as api from '../utils/api';
import styles from './ModifyDepositModal.module.css';
import MessageBox from './MessageBox';
import { useProgressBar } from '../context/ProgressBarContext';

function ModifyDepositModal({ onClose, transactionToModify, onDepositModified }) {
  const [amount, setAmount] = useState(transactionToModify?.txnAmount || '');
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const { showProgressBar, updateProgressBar, hideProgressBar } = useProgressBar();
  const [activePreviewData, setActivePreviewData] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      const fileType = file.type.includes('image') ? 'image' : (file.type === 'application/pdf' ? 'pdf' : 'other');
      setActivePreviewData({ url: URL.createObjectURL(file), type: fileType });
    } else {
      setActivePreviewData(null);
    }
  };

  const handleSubmit = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      setMessage({ type: 'error', text: 'Please enter a valid amount.' });
      return;
    }

    setIsUploading(true);
    showProgressBar();
    updateProgressBar(30);

    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      updateProgressBar(60);

      const updatedTxnData = {
        txnAmount: parseFloat(amount),
      };

      let { data: updatedTransaction } = await api.updateTransaction(transactionToModify._id, updatedTxnData);

      if (selectedFile) {
        const formData = new FormData();
        formData.append('paymentProof', selectedFile);
        const { data: proofUploadResult } = await api.uploadPaymentProof(updatedTransaction._id, formData);
        updatedTransaction = { ...updatedTransaction, paymentProof: proofUploadResult.paymentProof };
      }
      
      updateProgressBar(90);
      await new Promise(resolve => setTimeout(resolve, 500));
      
      onDepositModified(updatedTransaction);
      setMessage({ type: 'success', text: 'Deposit updated successfully!' });
      setTimeout(() => {
        onClose();
      }, 1500);

    } catch (err) {
      const msg = err.response?.data?.msg || 'An unexpected error occurred. Please try again.';
      setMessage({ type: 'error', text: `Operation failed: ${msg}` });
    } finally {
      hideProgressBar();
      setIsUploading(false);
    }
  };

  const handleClosePreview = () => {
    setActivePreviewData(null);
  };

  return (
    <div className={styles['modal-overlay']}>
      {message && (
        <MessageBox
          message={message.text}
          type={message.type}
          onClose={() => setMessage(null)}
        />
      )}
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <h3>Modify Deposit</h3>
          <button onClick={onClose} className={styles['close-btn']}>&times;</button>
        </div>
        <div className={styles['modal-content']}>
          <div className={styles['form-group']}>
            <label>Correct Payment Amount:</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className={styles['form-control']}
            />
          </div>
          <div className={styles['form-group']}>
            <label>Change Proof of Payment:</label>
            <input
              type="file"
              onChange={handleFileChange}
              className={styles['form-control']}
            />
          </div>

          {activePreviewData && (
            <div className={styles['image-preview-container']}>
              <button onClick={handleClosePreview} className={styles['close-preview-btn']}>&times;</button>
              <img src={activePreviewData.url} alt="Proof" className={styles['preview-image']} />
            </div>
          )}

          <div className={styles['update-button-container']}>
            <button
              className={styles['btn-primary']}
              onClick={handleSubmit}
              disabled={isUploading}
            >
              {isUploading ? 'Updating...' : 'Update Deposit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModifyDepositModal;